import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'

const BlockStyleOne = () => {
    return (
        <Fragment>
            <div className="block-style-one pt-10 mb-45">
                <h6 className="sub-title mb-15">CODAM 소개</h6>
                <h2 className="mb-20">기업의 디지털 경쟁력을 완성하는 IT 솔루션 파트너</h2>
                <p>CODAM은 기업의 업무 환경과 비즈니스 목표를 깊이 이해하고, 실제 운영 가능한 시스템을 구축합니다. 단순 개발을 넘어 안정적인 운영까지 함께합니다.</p>
                <ul className="block-box list-none">
                    <li>
                        <Link to="/contact">
                            <span className="img-bg"><img src="assets/img/icon/icon-1a.svg" alt="운영 안정성 아이콘"/></span>
                            <span>24/7 운영 모니터링</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/contact">
                            <span className="img-bg"><img src="assets/img/icon/icon-2a.svg" alt="전문 지원 아이콘"/></span>
                            <span>전담 기술 지원</span>
                        </Link>
                    </li>
                </ul>
                <Link className="theme_btn mt-60" to="/about">회사 소개 보기</Link>
            </div>
        </Fragment>
    )
}

export default BlockStyleOne
